import { postRequest } from "@network";
import { INSTANCE_URL } from "@constant";

export const SOCIAL_DETAILS = "SOCIAL_DETAILS";
export const SHOW_LOGIN = "SHOW_LOGIN";
export const ACCESS_TOKEN = "ACCESS_TOKEN";

export const fetchLinkedInProfile = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/social_promotion`;
  let body = { code: data, type: "linkedin" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback(response);
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const createSocialPost = (session, data, type, callback) => {
  let url = `${INSTANCE_URL}/api/v2/social_promotion`;
  let body = {
    ...data,
    type: type === "linkedin" ? "linkedin_createPost" : "facebook_createPost",
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback(response);
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchXProfile = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/social_promotion`;
  let body = { code: data, type: "x" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback(response);
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchSocialPosts = (session, body, callback) => {
  let url = `${INSTANCE_URL}/api/v2/social_promotion`;

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback(response.data);
      },
      (error) => {
        callback([]);
      }
    );
  };
};
